import { createSelector } from "reselect";
import { cardsByPosition, carouselCards } from "../../utils/showcase/showcaseCards";

const selectShowcaseReducer = state => state.showcase;

export const selectPreSelectedCardType = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.preSelectedCardType
);
export const selectPreSelectedCardId = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.preSelectedCardId
);
export const selectSelectedCardId = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.selectedCardId
);
export const selectNewSelectionCardData = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.newSelectionCardData
)
export const selectShowcaseCardsById = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.cardsById
)
export const selectDreamTeamCardData_MLB = createSelector(
    [selectShowcaseCardsById],
    (cardsById) => cardsByPosition(cardsById)
)
export const selectCarouselCards = createSelector(
    [selectShowcaseCardsById],
    (cardsById) => carouselCards(cardsById)
)
export const selectIsAddingCardImgs = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.isAddingCardImgs
)
export const selectIsEditingCard = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.isEditingCard
)
export const selectIsMovingCard = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.isMovingCard
)
export const selectIsViewingNewSelection = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.isViewingNewSelection
)
export const selectCardImgsWereAdded = createSelector(
    [selectShowcaseReducer],
    (showcase) => showcase.cardImgsWereAdded
)